module.exports = __webpack_public_path__ + "img/znlyjkxt3.55eddbfc.jpg";